import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps} from '../types';
import useUpdateOrder from '../util/use-update-orders';
import {useNavigate} from 'react-router-dom';

const useChangePaymentMethod = (orderId: string) => {
  const updateOrder = useUpdateOrder();
  const navigate = useNavigate();

  const onSuccess = (data: OrderProps) => {
    updateOrder(data, data.currentStatusName);
    navigate(-1);
  };

  return useApiMutation({
    url: `/orders/${orderId}/payment-method`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar forma de pagamento',
    successTitle: 'Alteração de forma de pagamento',
    successMessage: 'Forma de pagamento alterada com sucesso',
    onSuccess,
  });
};

export default useChangePaymentMethod;
